import React from "react";
import ReactECharts from "echarts-for-react";
import COLOR_ORDINAL from "../COLOR_ORDINAL";
import styles from "./styles.module.scss";
import formatNumber from "../../utils/formatNumber";

const MOCK_DATA = [
    {
        name: null,
        data: [
            {
                name: "沒有",
                value: "0.9329",
            },
            {
                name: "有",
                value: "0.0546",
            },
            {
                name: "不記得",
                value: "0.0125",
            },
        ],
    },
];

function PieChart({ data = MOCK_DATA, statisticsType = 1 }) {
    if (!data || data.length === 0) return null;

    const chartData = data[0].data;

const option = {
    series: [
        {
            type: "pie",
            radius: ["0%", "65%"], // 縮小圓餅圖
            center: ["50%", "50%"],
            hoverAnimation: false,
            labelLine: {
                show: true,
                length: 20, // 第一段線的長度
                length2: 30, // 第二段線的長度
                lineStyle: {
                    width: 1,
                },
            },
            data: chartData.map((item) => ({
                name: item.name,
                value: parseFloat(item.value),
                label: {
                    show: true,
                    position: "outside",
                    distanceToLabelLine: 15,
                    formatter: (params) => {
                        const name = params.name;
                        const value = formatNumber(
                            params.value,
                            statisticsType
                        );

                        if (name.includes("~")) {
                            const parts = name.split("~");
                            return `${parts[0]}~\n${parts[1]}(${value})`;
                        } else if (name.includes("【訪員請紀錄】")) {
                            const parts = name.split("【訪員請紀錄】");
                            return `${parts[0]}\n【訪員請紀錄】${parts[1]}(${value})`;
                        } else if (name.length > 6) {
                            const midpoint = Math.ceil(name.length / 2);
                            const line1 = name.slice(0, midpoint);
                            const line2 = name.slice(midpoint);
                            return `${line1}\n${line2}(${value})`;
                        }

                        return `${name}(${value})`;
                    },
                    fontSize: 14,
                    lineHeight: 14,
                    align: "center",
                    overflow: "break",
                },
            })),
            emphasis: {
                scale: false,
                scaleSize: 0,
            },
        },
    ],
    color: COLOR_ORDINAL,
};

    return (
        <div className={`${styles.pieChartContainer} pie-chart`}>
            <div className={styles.pieChart}>
                <ReactECharts
                    option={option}
                    style={{
                        height: `800px`,
                        width: `800px`,
                    }}
                />
            </div>
        </div>
    );
}

export default PieChart;
